import { useCallback } from 'react'

import logo from '@/images/logo.svg'

import firstScreenBg from '@/images/bg/first-screen-bg.jpg'
import firstScreenBgMob from '@/images/bg/first-screen-bg-mob.jpg'
import firstScreenBgTablet from '@/images/bg/first-screen-bg-tablet.jpg'
import firstScreenBgTabletBig from '@/images/bg/first-screen-bg-tablet-big.jpg'

import firstScreenDecor from '@/images/bg/first-screen-bg.png'
import firstScreenDecorTablet from '@/images/bg/first-screen-bg-tablet.png'
import firstScreenDecorTabletBig from '@/images/bg/first-screen-bg-tablet-big.png'

import firstScreenCup from '@/images/bg/first-screen-cup.png'
import firstScreenCupMob from '@/images/bg/first-screen-cup-mob.png'
import firstScreenCupTablet from '@/images/bg/first-screen-cup-tablet.png'
import firstScreenCupTabletBig from '@/images/bg/first-screen-cup-tablet-big.png'

const Header = () => {
  const onClick = useCallback(() => {
    const element =
      document.getElementById('records') ||
      document.getElementById('stepperMobile')

    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }, [])

  return (
    <section className="first-screen">
      <div className="first-screen-block img-wrap">
        <div className="first-screen-block-logo">
          <a
            href="https://2gis.ru"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={logo} alt="2ГИС" />
          </a>
        </div>

        <h1 className="first-screen-block__title">
          Карта рекордов
        </h1>

        <div className="first-screen-block__text">
          Россия глубока, широка и высока.{' '}
          <br className="tablet-true" />
          Это точно знает 2ГИС, <br className="mob-true" />
          <br />
          потому что мы всё измерили <br className="mob-true" />
          и подсчитали. <br className="tablet-true" />
          Теперь мы знаем, <br className="mob-true" />
          <br />
          где самый многоквартирный <br className="mob-true" />
          в стране дом, самая большая <br />
          бесплатная парковка <br className="mob-true" />
          и самая длинная улица.
        </div>

        <a
          href="https://2gis.onelink.me/nw2S/q7h8k5s4"
          target="_blank"
          rel="noopener noreferrer"
          className="first-screen-block_btn btn"
        >
          <span>Посмотреть рекорды на карте</span>
        </a>

        <div className="first-screen-more">
          <button
            className="toggle-icon"
            type="button"
            aria-label="Узнать больше"
            onClick={onClick}
          >
            <span className="toggle-icon__dot" />
          </button>

          <div className="first-screen-more_span">
            узнать больше
          </div>
        </div>

        <picture className="img-bg">
          <source
            srcSet={firstScreenBgMob}
            media="(max-width: 500px)"
          />

          <source
            srcSet={firstScreenBgTablet}
            media="(max-width: 1025px)"
          />

          <source
            srcSet={firstScreenBgTabletBig}
            media="(max-width: 1200px)"
          />

          <img
            src={firstScreenBg}
            alt=""
            className="img-bg"
          />
        </picture>
      </div>

      <picture>
        <source
          srcSet={firstScreenDecor}
          media="(max-width: 500px)"
        />

        <source
          srcSet={firstScreenDecorTablet}
          media="(max-width: 1025px)"
        />

        <source
          srcSet={firstScreenDecorTabletBig}
          media="(max-width: 1200px)"
        />

        <img
          src={firstScreenDecor}
          alt=""
          className="first-screen-bg"
        />
      </picture>

      <picture>
        <source
          srcSet={firstScreenCupMob}
          media="(max-width: 500px)"
        />

        <source
          srcSet={firstScreenCupTablet}
          media="(max-width: 1025px)"
        />

        <source
          srcSet={firstScreenCupTabletBig}
          media="(max-width: 1200px)"
        />

        <img
          src={firstScreenCup}
          alt=""
          className="first-screen-cup"
        />
      </picture>
    </section>
  )
}

export default Header
